import styled from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.getSize(1)};
  padding: ${({theme}) => theme.getSize(1)};
  border-bottom: 1px solid ${({theme}) => theme.colors.palettes.neutral[30][100]};
  background-color: ${({theme}) => theme.colors.palettes.neutral[10][100]};
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.getSize(1)};
  padding-right: ${({theme}) => theme.getSize(1)};
  border-right: 1px solid ${({theme}) => theme.colors.palettes.neutral[40][100]};

  &:last-child {
    border-right: 0;
    padding-right: 0;
  }
`;

export type ToolbarButtonProps = {
  $isActive?: boolean;
};

export const ToolbarButton = styled.button<ToolbarButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  width: ${({theme}) => theme.getSize(8)};
  height: ${({theme}) => theme.getSize(8)};
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.palettes.blue[20][100] : 'transparent'};
  color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.severity.informational : theme.colors.text.primary};
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background-color: ${({theme, $isActive}) =>
      $isActive ? theme.colors.palettes.blue[30][100] : theme.colors.palettes.neutral[30][100]};
  }

  &:active:not(:disabled) {
    background-color: ${({theme}) => theme.colors.palettes.blue[30][100]};
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const ToolbarIcon = styled.span`
  display: inline-flex;
  width: ${({theme}) => theme.getSize(4)};
  height: ${({theme}) => theme.getSize(4)};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ToolbarChoiceWrapper = styled.div`
  min-width: ${({theme}) => theme.getSize(28)};

  .eag--choice__control {
    padding-right: ${({theme}) => theme.getSize(2)};
    cursor: pointer;
  }

  /* Hide the IconButton DropdownIndicator wrapper — we use a CSS chevron instead */
  .eag--choice__indicators-container > div {
    display: none;
  }

  /* Plain CSS triangle chevron appended to the control */
  .eag--choice__control::after {
    content: '';
    display: inline-block;
    flex-shrink: 0;
    align-self: center;
    margin-left: ${({theme}) => theme.getSize(1)};
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid ${({theme}) => theme.colors.text.secondary};
  }
`;
